
import React from 'react';
import { PopupContent } from '@/types/popup-system';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

interface Windows95PopupProps {
  content: PopupContent;
  onDismiss: () => void;
  onAction?: (action: string) => void;
}

export const Windows95Popup = ({ content, onDismiss, onAction }: Windows95PopupProps) => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20">
      <div className="w-full max-w-md mx-4">
        {/* Main dialog window */}
        <div className="bg-win95-gray border-2 border-t-white border-l-white border-r-gray-400 border-b-gray-400 shadow-lg">
          {/* Title bar */}
          <div className="bg-gradient-to-r from-blue-700 to-blue-600 text-white px-2 py-1 flex justify-between items-center">
            <div className="flex items-center gap-1">
              <div className="w-4 h-4 bg-red-500 flex items-center justify-center text-white text-xs font-bold">
                !
              </div>
              <span className="text-sm font-bold">{content.title}</span>
            </div>
            {content.dismissible && (
              <button 
                onClick={onDismiss}
                className="w-5 h-5 bg-win95-gray border border-t-white border-l-white border-r-gray-400 border-b-gray-400 flex items-center justify-center text-xs hover:bg-gray-300 active:border-t-gray-400 active:border-l-gray-400 active:border-r-white active:border-b-white"
              >
                ×
              </button>
            )}
          </div>
          
          {/* Dialog content */}
          <div className="p-4 bg-win95-gray">
            <div className="flex items-start gap-3 mb-6">
              {/* Warning icon */}
              <div className="w-8 h-8 bg-yellow-400 border border-gray-600 flex items-center justify-center text-black text-lg font-bold flex-shrink-0">
                !
              </div>
              {/* Message text */}
              <div className="flex-1 pt-1">
                <p className="text-sm text-black leading-relaxed font-sans">
                  {content.message}
                </p>
              </div>
            </div>
            
            {/* Buttons */}
            <div className="flex justify-center gap-2">
              {content.actionButtons && content.actionButtons.length > 0 ? (
                content.actionButtons.map((button, index) => (
                  <button
                    key={index}
                    onClick={() => onAction?.(button.action)}
                    className="px-6 py-1 bg-win95-gray border-2 border-t-white border-l-white border-r-gray-400 border-b-gray-400 text-black text-sm font-sans hover:bg-gray-300 active:border-t-gray-400 active:border-l-gray-400 active:border-r-white active:border-b-white min-w-[60px]"
                  >
                    {button.text}
                  </button>
                ))
              ) : (
                <button
                  onClick={onDismiss}
                  className="px-6 py-1 bg-win95-gray border-2 border-t-white border-l-white border-r-gray-400 border-b-gray-400 text-black text-sm font-sans hover:bg-gray-300 active:border-t-gray-400 active:border-l-gray-400 active:border-r-white active:border-b-white min-w-[60px]"
                >
                  OK
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
